import { render, staticRenderFns } from "./MainAction.vue?vue&type=template&id=eb10eda8&scoped=true&"
import script from "./MainAction.vue?vue&type=script&lang=ts&"
export * from "./MainAction.vue?vue&type=script&lang=ts&"
import style0 from "./MainAction.vue?vue&type=style&index=0&id=eb10eda8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb10eda8",
  null
  
)

export default component.exports